import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  change(event) {
    const frame = document.getElementById('parent_variants');
    if (event.target.value) {
      frame.src=event.target.value;
    } else {
      frame.src=event.target.dataset.blank;
    }

    frame.reload();
  }
}